// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZMCz0Z4xnFod9oUDxLlP{flex-grow:1;margin-left:16px;display:flex;position:relative}.sx0deE48FtrqQuUsMMF3{gap:8px;display:flex}.YDkSiHwPR4GdIwSpqodY{word-break:break-word}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ZMCz0Z4xnFod9oUDxLlP`,
	"nameCellWrapper": `sx0deE48FtrqQuUsMMF3`,
	"tooltipText": `YDkSiHwPR4GdIwSpqodY`
};
export default ___CSS_LOADER_EXPORT___;
